import React, { useContext } from 'react';

import { IComponent } from '../../component';
import { ThemeContext } from '../../store/ThemeProvider';

import './ImageTips.scss';

const ImageTips = function (props: IComponent) {
  const { h1Color, h2Color, componentColor, backgroundColor } =
    useContext(ThemeContext);

  const nowYear = new Date().getFullYear();

  return (
    <div className="imagetips" style={{ backgroundColor: componentColor }}>
      <div className="h1 header" style={{ color: h2Color, display: 'none' }}>
        <div className="line" />
        <span style={{ color: h1Color, margin: 10 }}>TIPS</span>
        <div className="line" />
      </div>
      <p
        className="h1"
        style={{ color: h1Color, marginTop: 8, fontWeight: 600 }}
      >
        即享影像，让分享更美
      </p>
      <p className="h2" style={{ color: h2Color, marginTop: 4 }}>
        JFOTO@2015-{nowYear}
      </p>
    </div>
  );
};

export default ImageTips;